<!--
	* @Description: 班干部会议记录 详情
	* @Author: ztw
	* @Date: 2023-03-01 17:51:17.216
 * @LastEditors: Xyyyyyy
 * @LastEditTime: 2023-07-17 17:21:39
-->
<template>
  <div>
    <el-dialog class="w800 h630" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-descriptions :column="2" border>
        <el-descriptions-item label="学期" label-align="right" align="left" width="120px" span="2">{{ruleForm.xqmc}}</el-descriptions-item>
        <el-descriptions-item label="班级" label-align="right" align="left" width="120px" span="2">{{ruleForm.xzbmc}}</el-descriptions-item>
        <el-descriptions-item label="主持人" label-align="right" align="left" width="120px" span="2">{{ruleForm.zcr}}</el-descriptions-item>
        <el-descriptions-item label="时间" label-align="right" align="left" width="120px" span="2">{{ruleForm.sj}}</el-descriptions-item>
        <el-descriptions-item label="会议地址" label-align="right" align="left" width="120px" span="2">{{ruleForm.hydz}}</el-descriptions-item>
        <el-descriptions-item label="参加人数" label-align="right" align="left" width="120px" span="2">{{ruleForm.cjrs}}</el-descriptions-item>
        <el-descriptions-item label="缺席人数" label-align="right" align="left" width="120px" span="2">{{ruleForm.qxrs}}</el-descriptions-item>
        <el-descriptions-item label="会议记录" label-align="right" align="left" width="120px" span="2">{{ruleForm.hyjl}}</el-descriptions-item>
      </el-descriptions>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="info" @click="closeWindow('openDetail', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadData, closeWindow } from '@/api/common.js'

const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const ruleForm = ref({})
const emits = defineEmits(['update:openDetail'])

watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      loadData({
        url:
          '/api/v2/xuesheng/banzhurengongzuobanganbuhuiyijilu/' + props.row.id,
        ruleForm,
        loadSuccess: function (res) {}
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
